import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.35355 1.64645C6.15829 1.45118 5.84171 1.45118 5.64645 1.64645L2.64645 4.64645C2.45118 4.84171 2.45118 5.15829 2.64645 5.35355C2.84171 5.54882 3.15829 5.54882 3.35355 5.35355L5.5 3.20711L5.5 10C5.5 10.2761 5.72386 10.5 6 10.5C6.27614 10.5 6.5 10.2761 6.5 10L6.5 3.20711L8.64645 5.35355C8.84171 5.54882 9.15829 5.54882 9.35355 5.35355C9.54882 5.15829 9.54882 4.84171 9.35355 4.64645L6.35355 1.64645Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.47145 2.19526C8.2111 1.93491 7.78899 1.93491 7.52864 2.19526L3.52864 6.19526C3.26829 6.45561 3.26829 6.87772 3.52864 7.13807C3.78899 7.39842 4.2111 7.39842 4.47145 7.13807L7.33337 4.27614L7.33337 13.3333C7.33337 13.7015 7.63185 14 8.00004 14C8.36823 14 8.66671 13.7015 8.66671 13.3333L8.66671 4.27614L11.5286 7.13807C11.789 7.39842 12.2111 7.39842 12.4714 7.13807C12.7318 6.87772 12.7318 6.45561 12.4714 6.19526L8.47145 2.19526Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5892 2.74408C10.2638 2.41864 9.73614 2.41864 9.4107 2.74408L4.4107 7.74408C4.08527 8.06951 4.08527 8.59715 4.4107 8.92259C4.73614 9.24803 5.26378 9.24803 5.58922 8.92259L9.16663 5.34518L9.16663 16.6667C9.16663 17.1269 9.53972 17.5 9.99996 17.5C10.4602 17.5 10.8333 17.1269 10.8333 16.6667L10.8333 5.34518L14.4107 8.92259C14.7361 9.24803 15.2638 9.24803 15.5892 8.92259C15.9147 8.59715 15.9147 8.06951 15.5892 7.74408L10.5892 2.74408Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.50008 9.99988V3.20691L3.3536 5.3534C3.15834 5.54866 2.84183 5.54866 2.64657 5.3534C2.45131 5.15814 2.45131 4.84163 2.64657 4.64637L5.64657 1.64637L5.68465 1.61219C5.88104 1.45201 6.17054 1.46331 6.3536 1.64637L9.3536 4.64637L9.38778 4.68445C9.54796 4.88084 9.53666 5.17034 9.3536 5.3534C9.17054 5.53646 8.88104 5.54775 8.68465 5.38758L8.64657 5.3534L6.50008 3.20691V9.99988C6.50008 10.276 6.27623 10.4999 6.00008 10.4999C5.72394 10.4999 5.50008 10.276 5.50008 9.99988Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33345 13.3332V4.27589L4.47147 7.13787C4.21112 7.39821 3.78911 7.39821 3.52876 7.13787C3.26841 6.87752 3.26841 6.45551 3.52876 6.19516L7.52876 2.19516L7.57954 2.14958C7.84139 1.93602 8.22739 1.95108 8.47147 2.19516L12.4715 6.19516L12.517 6.24594C12.7306 6.50779 12.7155 6.89379 12.4715 7.13787C12.2274 7.38194 11.8414 7.397 11.5795 7.18344L11.5288 7.13787L8.66678 4.27589V13.3332C8.66678 13.7014 8.3683 13.9998 8.00011 13.9998C7.63192 13.9998 7.33345 13.7014 7.33345 13.3332Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.16669 16.6665V5.34486L5.58921 8.92233C5.26377 9.24777 4.73626 9.24777 4.41083 8.92233C4.08539 8.59689 4.08539 8.06938 4.41083 7.74395L9.41083 2.74395L9.4743 2.68698C9.80161 2.42002 10.2841 2.43885 10.5892 2.74395L15.5892 7.74395L15.6462 7.80742C15.9131 8.13473 15.8943 8.61723 15.5892 8.92233C15.2841 9.22743 14.8016 9.24626 14.4743 8.9793L14.4108 8.92233L10.8334 5.34486V16.6665C10.8334 17.1267 10.4603 17.4998 10 17.4998C9.53978 17.4998 9.16669 17.1267 9.16669 16.6665Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconArrowNarrowUp: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"arrow-narrow-up"} {...props} />
);
